import { render, staticRenderFns } from "./revision-message.vue?vue&type=template&id=b61dd338&"
import script from "./revision-message.vue?vue&type=script&lang=js&"
export * from "./revision-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports